var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFaCheck({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "496px",
    height: "496px",
    viewBox: "0 0 496 496",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "FA-Check") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "FA-Check",
    fill: "#4BB543",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M496,248 C496,384.967 384.967,496 248,496 C111.033,496 0,384.967 0,248 C0,111.033 111.033,0 248,0 C384.967,0 496,111.033 496,248 Z M219.314,379.314 L403.314,195.314 C409.562,189.066 409.562,178.935 403.314,172.687 L380.687,150.06 C374.439,143.811 364.308,143.811 358.059,150.06 L208,300.118 L137.941,230.059 C131.693,223.811 121.562,223.811 115.313,230.059 L92.686,252.686 C86.438,258.934 86.438,269.065 92.686,275.313 L196.686,379.313 C202.935,385.562 213.065,385.562 219.314,379.314 L219.314,379.314 Z",
    id: "Shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaCheck);
export default __webpack_public_path__ + "static/media/FA-Check.564bbf82874772a4881b4d54fc782241.svg";
export { ForwardRef as ReactComponent };